// Debounce utility function
function debounce(fn, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
}

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    console.log('PredictiveSearch');
  }

  connectedCallback() {
    this.input = this.querySelector('input[name="q"]');

    // Find the .predictive-results-wrapper container (where we inject predictive results)
    const quickSearch = this.closest('.quick-search');
    if (quickSearch) {
      const resultsContainer = quickSearch.querySelector(
        '.quick-search--results[data-quick-search-content]'
      );
      this.predictiveSearchWrapper = resultsContainer?.querySelector(
        '.predictive-results-wrapper'
      );
      this.curatedContent = resultsContainer?.querySelector(
        '.quick-search--content'
      );
    }

    // Fallback to internal div if quick-search structure not found
    if (!this.predictiveSearchWrapper)
      this.predictiveSearchWrapper = this.querySelector('.predictive-search');

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
        console.log('onChange', event);
      }, 100).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    // Only show predictive results when input is more than 1 character
    if (searchTerm.length <= 1) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `${routes.predictive_search_url}?q=${searchTerm}&resources[limit]=8&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,variants.barcode&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        if (resultsMarkup != this.predictiveSearchWrapper.innerHTML) {
          // Inject into the wrapper instead of replacing entire container
          this.predictiveSearchWrapper.innerHTML = resultsMarkup;
          this.open();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    // Hide curated content
    if (this.curatedContent) this.curatedContent.style.display = 'none';

    // Show predictive results
    const resultsContainer = this.predictiveSearchWrapper?.querySelector(
      '.predictive-search-results'
    );
    if (resultsContainer) resultsContainer.classList.add('is-visible');
  }

  close() {
    // Show curated content
    if (this.curatedContent) this.curatedContent.style.display = '';
    // Clear predictive results from wrapper
    if (this.predictiveSearchWrapper)
      this.predictiveSearchWrapper.innerHTML = '';
  }
}

customElements.define('predictive-search', PredictiveSearch);
